export default __webpack_public_path__ + "static/media/Rizzo-Italian-Grill.4b7c5079.jpg";